module.exports = __webpack_public_path__ + "img/random.f4b60948.jpg";